// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"button-wrapper__1YRFk","icon-wrapper":"icon-wrapper__1XJzi","icon":"icon__Dc4mX","desktop-icon":"desktop-icon__21VHs"};